import React from 'react';
import styles from './styles.module.scss';
import { markdownToHtml } from '@/utils/markdown-to-html';

interface LabelProps {
  text: string;
  maxLines?: number;
  className?: string;
  style?: React.CSSProperties;
  isHtml?: boolean;
}

export const Label: React.FC<LabelProps> = ({
  text,
  maxLines = 10000,
  className = '',
  style,
  isHtml = false,
}) => {
  const clampStyle: React.CSSProperties = {
    WebkitLineClamp: maxLines,
  };

  return (
    <div
      className={`${styles.label} ${className}`}
      style={{ ...clampStyle, ...style }}
      dangerouslySetInnerHTML={{ __html: isHtml ? text : markdownToHtml(text) }}
    />
  );
};
